<template>
  <a-card :bordered="false" title="商品分组">
    <a-row :span="24">
      <a-col :span="8">
        <a-form-item label="分组名称" v-bind="searchItemLayout">
          <a-input-search v-model="queryParams.groupName" placeholder="请输入分组名称" @search="onSearch"/>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item>
          <a-button style="margin-left: 20px" type="primary" @click="createGroupEvent">创建商品分组</a-button>
        </a-form-item>
      </a-col>
    </a-row>
    <custom-paging-dragging-list
      :requestPromise="getRequest"
      :columns="columns"
      @draggable="onDraggable"
      ref="pageList"
    >
      <div class="image-table" slot="slotImage" slot-scope="rowItem">
        <CustomImage v-show="rowItem.record.groupIcon" width="39" height="14"
                     :imageUrl="rowItem.record.groupIcon"></CustomImage>
      </div>
      <template slot="sort" slot-scope="rowItem">{{ rowItem.index + 1 }}</template>
      <span slot="action" slot-scope="rowItem">
          <a @click="toEditorEvent(rowItem.record)">编辑</a>
        <template v-if="rowItem.record.groupPreset===0">
          <a-divider type="vertical"></a-divider>
          <a-popconfirm
            title="是否要删除当前分组？"
            @confirm="deleteEvent(rowItem.record)">
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </custom-paging-dragging-list>
  </a-card>
</template>

<script>
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'
import searchForm from '../../utils/mixins/searchFormMixins'

export default {
  name: 'GoodsGroups',
  components: { CustomPagingDraggingList },
  mixins: [searchForm],
  data() {
    return {
      selectedDate: undefined,
      queryParams: {},
      columns: [
        {
          title: 'ID',
          width: '120px',
          dataIndex: 'groupId'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: '60px',
          scopedSlots: { customRender: 'sort' }

        },
        {
          title: '分组图标',
          dataIndex: 'groupIcon',
          width: '100px',
          scopedSlots: { customRender: 'slotImage' }
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '商品数量',
          dataIndex: 'proNum'
        },
        {
          title: '类型',
          dataIndex: 'convertGroupPreset',
          width: '120px'
        },
        {
          title: '状态',
          dataIndex: 'groupStatusStr'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '130px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    getRequest(parameter) {
      const requestParams = {
        ...this.queryParams,
        ...parameter
      }
      return this.getHttpServices().getProService().post('proGroup/findProGroupList', requestParams)
    },
    onDraggable(params) {
      const sortParams = {
        idList: params.dataList.map(item => item.groupId),
        pageSize: params.pageSize,
        pageNum: params.pageNo
      }
      this.getHttpServices().getProService().post('proGroup/orderByProGroup', sortParams)
        .then(res => {
          this.$message.success('排序成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSearch() {
      this.$refs.pageList.refresh()
    },
    createGroupEvent() {
      this.$router.push({
        name: 'CreateProductGroup',
        query: {
          type: 2
        }
      })
    },
    deleteEvent(record) {
      this.getHttpServices()
        .getProService()
        .post('proGroup/delProGroup?groupId=' + record.groupId)
        .then(res => {
          this.$message.success('成功删除')
          this.$refs.pageList.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    toEditorEvent(record) {
      this.$router.push({
        name: 'CreateProductGroup',
        query: {
          type: 1,
          groupId: record.groupId
        }
      })
    }
  }

}
</script>
<style scoped>
.image-table {
  height: 28px;
  min-width: 68px;
}
</style>